import React, { Component } from 'react';
import { getStartedFormInputs } from './GetStarteModalInputs';
import { GetStartedModalStyles } from './GetStartedModalStyles';
import { getFormErrors, isValidField } from '../../services/formService';
import { FormStyles } from '../../styles/FormStyles';
import Input from '../Input/Input';
import { registerUser } from '../../services/userService';
import { SiteAPI } from '../../config';

const AlreadyExists = () => (
  <div className="alert alert-danger">
    The email address you entered is already in use. Please sign in or try a different
    email address.
  </div>
);

const UserSuccess = () => (
  <div className="alert alert-success">
    Thank you! One of our representatives will contact you shortly.
  </div>
);

const getUrlVars = () => {
  const vars = {};
  const parts = window.location.href.replace(
    /[?&]+([^=&]+)=([^&]*)/gi,
    (m, key, value) => {
      vars[key] = value;
    }
  );
  return vars;
};

const getUrlParam = (parameter, defaultvalue = '') => {
  let urlparameter = defaultvalue;
  if (window.location.href.indexOf(parameter) > -1) {
    urlparameter = getUrlVars()[parameter];
  }
  return urlparameter;
};

class GetStartedModalComponent extends Component {
  state = {
    first_name: '',
    last_name: '',
    username: '',
    phone: '',
    errors: [],
    form_is_loading: false,
    already_exists: false,
  };

  componentWillMount() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('modal-open');
  }

  componentWillUnmount() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('modal-open');
  }

  onInputChange = e => {
    this.setState({ [e.target.name]: e.target.value });
    this.handleKeyUp(e);
  };

  dismiss = () => {
    this.props.unmountMe();
  };

  handleKeyUp = e => {
    const field = e.target;
    const { errors } = this.state;
    if (field.checkValidity()) {
      const newErrors = errors.filter(error => error !== field.name);
      this.setState({ errors: newErrors });
    }
  };

  submit = async e => {
    e.preventDefault();

    const tracking = {
      leadSource: 'ClientBooks',
      leadType: 'Start For Free',
    };

    const source = getUrlParam('source');

    if (source === 'legalzoom-app') {
      tracking.leadSource = 'LegalZoom';
      tracking.leadType = 'Partner Page Referral - App';
    }

    const errors = getFormErrors(e);
    this.setState({ errors });
    if (errors.length) return;

    const data = {
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      username: this.state.username,
      phone: this.state.phone,
    };

    this.setState({ form_is_loading: true });
    try {
      const user = await registerUser(
        data,
        `${SiteAPI.registerPartner}?leadSource=${tracking.leadSource}&leadType=${
          tracking.leadType
        }`
      );
      if (user.access_token) {
        // Thank you
        this.setState({
          already_exists: false,
          user_success: true,
          form_is_loading: false,
          first_name: '',
          last_name: '',
          username: '',
          phone: '',
        });
      } else if (user.id) {
        this.setState({
          already_exists: true,
          form_is_loading: false,
        });
      } else {
        // something went wrong
      }
    } catch (error) {
      console.log(error.repsonse);
    }
  };

  render() {
    return (
      <GetStartedModalStyles className="modal" tabIndex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Let’s Get Started</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={this.dismiss}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <FormStyles
                noValidate
                onSubmit={e => {
                  this.submit(e);
                }}
                className={this.state.form_is_loading ? 'is-loading' : ''}
              >
                <p>
                  Please enter your information below to begin your Free 30-Day Trial
                  using our client portal.
                </p>
                <div className="row">
                  {getStartedFormInputs.map(field => (
                    <div className="col-md-6" key={field.name}>
                      <Input
                        name={field.name}
                        label={field.label}
                        value={this.state[field.name]}
                        type={field.type}
                        handleOnChange={this.onInputChange}
                        required={field.required}
                        hasError={isValidField(this.state.errors, field.name)}
                        key={field.name}
                      />
                    </div>
                  ))}
                </div>

                {this.state.already_exists && <AlreadyExists />}
                {this.state.user_success ? (
                  <UserSuccess />
                ) : (
                  <button type="submit" className="btn btn-block btn-primary">
                    Sign Up
                  </button>
                )}
              </FormStyles>
            </div>
          </div>
        </div>
      </GetStartedModalStyles>
    );
  }
}

export default GetStartedModalComponent;
